// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jZNYj","form":"styles_form__ZQz0W","copyright":"styles_copyright__3Ebxs","links":"styles_links__h0nPM","_button":"styles__button__qF+jy"};